import api from '@/services/api'

const API_BASE_PATH = process.env.API_BASE_PATH

const S3 = require('axios').create()
const signedImageUrl = `${API_BASE_PATH}/images`

const getSignedURL = (path, payload) => api.post(path, payload).then(res => res.data)

const sendUploadComplete = path => api.post(path, null)

const upload = ({path, file, fileName, fileType, headers, progressCallback}) => getSignedURL(path, {
  filename: fileName
}).then(async res => {
  await uploadToS3(res.signed_url, file, fileType, (headers || {}), ev => progressCallback(ev))

  return res.file_path
}).catch((err) => {
  console.log(err)
})

const uploadAd = async (path, file, headers, progressCallback) => upload({
  path, file, fileName: file.name, fileType: file.type, headers: (headers || {}), progressCallback
})

const uploadAudio = async (path, file, headers, progressCallback) => uploadToS3(
  path, file, file.type, (headers || {}), ev => progressCallback(ev)
).then(res => res.data)

const uploadImage = async (file, headers, progressCallback) => upload({
  path: signedImageUrl, file: file.blob, fileName: file.name, fileType: file.blob.type, headers: (headers || {}), progressCallback
})

const uploadToS3 = (path, file, type, headers, progress) => S3.put(path, file, {
  onUploadProgress: progress,
  timeout: 0,
  headers: {
    ...{
      'Content-Type': type
    },
    ...(headers || {})
  }
}).then(res => res.data)

export default {
  getSignedURL,
  uploadAd,
  uploadAudio,
  uploadImage,
  uploadToS3,
  sendUploadComplete
}
